import * as React from 'react'
import cn from 'classnames'
import { FormattedHTMLMessage, FormattedMessage, MessageDescriptor } from 'react-intl'
import { Card, CardBody } from '../card'
import { ReactComponent as BankIdSvg } from '../../components/functional/basic-signup/form/bankid.svg'
import { ReactComponent as BankIdSvgWhite } from '../../components/functional/basic-signup/form/bankid-white.svg'
import styles from './bankidCard.module.scss'
import { commonKeyValues } from '../../lib/utils'
import Spinner from '../spinner'

export default function BankidCard({
  message,
  status,
  style,
  brand,
  className,
  cancelMessage,
  onCancel,
  waitingForBankid,
  skipBankidLogo,
  withSpinner,
}: {
  message?: string | null
  status?: string | null | React.ReactNode
  style?: React.CSSProperties
  className?: string
  brand?: {
    logo: string
    logoAlt: string
    message?: MessageDescriptor
  } | null
  cancelMessage?: MessageDescriptor
  onCancel?: () => void
  waitingForBankid?: boolean
  skipBankidLogo?: boolean
  withSpinner?: boolean
}) {
  return (
    <Card className={cn(styles.card, className)} style={style}>
      <CardBody className={styles.body}>
        {brand ? (
          <div className={styles.header}>
            <img alt={brand.logoAlt} src={brand.logo} style={{ height: '100px' }} />
            {brand.message && <FormattedMessage {...brand.message} tagName="p" />}
          </div>
        ) : (
          <>
            <BankIdSvg style={{ height: '100px' }} />
            {withSpinner && <Spinner style={{ marginBottom: 0 }} />}
          </>
        )}
      </CardBody>

      <div
        className={styles.text}
        style={{
          background: waitingForBankid ? '#5b9ee5' : '#fafbfd',
          color: waitingForBankid ? 'white' : 'auto',
        }}
      >
        <div className={styles.textContent}>
          {waitingForBankid && brand && !skipBankidLogo && <BankIdSvgWhite />}
          <div>
            {status && (
              <p
                className={styles.status}
                style={{
                  color: waitingForBankid ? 'white' : '#5c5d5f',
                  textAlign: waitingForBankid ? 'left' : 'center',
                }}
              >
                {status}
              </p>
            )}
            {message && (
              <p
                className={styles.message}
                style={{
                  color: waitingForBankid ? 'white' : '#5c5d5f',
                  textAlign: waitingForBankid ? 'left' : 'center',
                }}
              >
                {message}
              </p>
            )}
          </div>
        </div>

        {cancelMessage && onCancel && (
          <span
            className={styles.cancelCta}
            onClick={() => onCancel()}
            onKeyDown={(e) => {
              if (e.keyCode === commonKeyValues.enter) {
                e.preventDefault()
                onCancel()
              }
            }}
            role="button"
            style={{ color: waitingForBankid ? 'white' : '#5c5d5f' }}
            tabIndex={0}
          >
            <FormattedHTMLMessage {...cancelMessage} />
          </span>
        )}
      </div>
    </Card>
  )
}
